// Sends interaction events to the Ingestion (Interaction Server) service —
// a separate process/port from the Dashboard API. Fire-and-forget: never
// blocks the UI and never surfaces errors to the user, since these are
// analytics/recommendation signals, not user-facing actions.
import { useUserStore } from '../stores/user';

const ingestionUrl = process.env.VUE_APP_INGESTION_URL;

export function reportEvent(eventType, videoId = null, metadata = {}) {
  const userStore = useUserStore();

  // The Ingestion server requires auth - skip quietly if signed out rather
  // than sending a request that will just 401.
  if (!userStore.user?.name) {
    return;
  }

  if (!ingestionUrl) {
    // No VUE_APP_INGESTION_URL configured - nothing to send to.
    return;
  }

  fetch(`${ingestionUrl}/events`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ eventType, videoId, metadata }),
  }).catch((err) => {
    console.warn(`Failed to report ${eventType} to ingestion:`, err);
  });
}
